import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface WalletInputProps {
  onSubmit: (wallet: string) => void;
}

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '11px 14px',
  background: 'var(--ink-2)',
  border: '1px solid var(--rule)',
  color: 'var(--text)',
  fontFamily: 'var(--mono)',
  fontSize: 13,
  borderRadius: 0,
};

const WalletInput: React.FC<WalletInputProps> = ({ onSubmit }) => {
  const [wallet, setWallet] = useState('');
  const navigate = useNavigate();

  const handleViewHLVault = () => {
    navigate('/dashboard', {
      state: {
        vaultMode: true,
        vaults: [
          '0xdfc24b077bc1425ad1dea75bcb6f8158e10df303',
          '0x010461c14e146ac35fe42271bdc1134ee31c703a',
          '0x31ca8395cf837de08b24da3f660e77761dfb974b',
        ],
        initialActiveTab: 'Liquidity Vault',
      },
    });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(wallet);
    navigate(`/dashboard?wallet=${wallet}`);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <form
        onSubmit={handleSubmit}
        className="panel"
        style={{ padding: '28px 32px', width: '100%', maxWidth: 480 }}
      >
        <div
          className="tab-sm muted"
          style={{ fontSize: 9.5, letterSpacing: '0.12em', marginBottom: 14 }}
        >
          § WALLET LOOKUP
        </div>
        <h2
          className="serif"
          style={{
            fontSize: 22,
            fontWeight: 700,
            letterSpacing: '-0.02em',
            marginBottom: 18,
          }}
        >
          Open a Hyperliquid wallet
        </h2>
        <label style={{ display: 'block', marginBottom: 18 }}>
          <div className="tab-sm muted" style={{ fontSize: 9.5, marginBottom: 6 }}>
            ADDRESS
          </div>
          <input
            type="text"
            placeholder="0x…"
            value={wallet}
            onChange={(e) => setWallet(e.target.value)}
            style={inputStyle}
          />
        </label>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 10,
            justifyContent: 'space-between',
          }}
        >
          <button type="submit" className="btn btn-primary" style={{ flex: 1 }}>
            Open dashboard →
          </button>
          <button type="button" onClick={handleViewHLVault} className="btn" style={{ flex: 1 }}>
            View HL vaults
          </button>
        </div>
      </form>
    </div>
  );
};

export default WalletInput;
